module.exports = {"apiEndpoint":"https://jsonplaceholder.typicode.com/posts"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 83
// module chunks = 0